module.exports = __webpack_public_path__ + "ce89720071744f2665bc309cd08199cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/checkbox.png
// module id = 117
// module chunks = 0